module.exports = __webpack_public_path__ + "static/scale-model-of-inglewood-california-8ae2107437eaee64a23e02fb0202cfc6.png";